import styled, { css, keyframes } from 'styled-components';

const fadeIn = props => css`
  ${keyframes`
    0% {opacity: 0;}
    100% {opacity: 1;}
  `}
`;

const NavigationMenuUnderlay = styled.div`
  background-color: rgba(0, 0, 0, 0.75);
  visibility: ${props => (props.open ? 'visible' : 'hidden')};
  opacity: ${props => (props.open ? '1' : '0')};
  width: 100%;
  height: 100%;
  position: fixed;
  z-index: 10;
  top: 0;
  left: 0;
  ${props => (props.open ? `animation: ${fadeIn} 0.3s ease-in;` : null)} animation-direction: alternate;
`;

export default NavigationMenuUnderlay;
